import { AwardDisplay } from 'components/common/Awards/AwardDisplay';
import { Award } from 'types/Search';
import { getNumberOfIcons, getSortedAwardsArray } from './awardsHelper';
import { SizingOptions } from 'components/common/Awards/types';
import { Tooltip } from '@mui/material';

interface SearchawardsProps {
  awards: Award[];
  certificationCount?: number;
  showAll?: boolean;
}

const SearchAward = ({
  awards,
  showAll,
  certificationCount
}: SearchawardsProps) => {
  const numberOfIconsToShow = getNumberOfIcons(
    awards.length,
    certificationCount ?? 0,
    'AWARD'
  );
  const sortedAwards = getSortedAwardsArray(awards);

  const visibleAwards = sortedAwards.slice(0, numberOfIconsToShow);
  const hiddenAwards = sortedAwards.slice(numberOfIconsToShow);

  return (
    <div className="search-certification">
      {awards && awards.length > 0 && (
        <>
          {/* //for product pages we show all awards */}
          {showAll ? (
            sortedAwards.map(award => (
              <AwardDisplay
                key={award.category.key}
                award={award}
                size={SizingOptions.SMALL}
              />
            ))
          ) : awards.length <= 2 ? (
            sortedAwards.map(award => (
              <AwardDisplay
                key={award.category.key}
                award={award}
                size={SizingOptions.SMALL}
              />
            ))
          ) : (
            <>
              {visibleAwards.map(award => (
                <AwardDisplay
                  key={award.category.key}
                  award={award}
                  size={SizingOptions.SMALL}
                />
              ))}

              {hiddenAwards.length > 0 && (
                <Tooltip title={`+${hiddenAwards.length} awards`}>
                  <span className="search-certification-container search-certification-container--plus">
                    <div className="search-certification-image search-certification-image--plus">
                      +{hiddenAwards.length}
                    </div>
                  </span>
                </Tooltip>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SearchAward;
